import React from 'react';

import { Button } from '@sravni/react-design-system';
import { Heading, Link, Text } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile, useStyles } from '@sravni/react-utils';
import { TOrganizationTypes } from '@sravni/ugc/lib/organizations/types';

import { ReviewModeration } from '../../../../ReviewModeration/ReviewModeration';
import { GreenCheck } from '../../../../UI/Icons/GreenCheck';

import styles from './published-step.module.scss';

type TPublishedStepProps = {
  organizationType: TOrganizationTypes;
  organizationAlias: string;
  reviewId: number;
};

export const PublishedStep: React.FC<TPublishedStepProps> = ({ organizationType, organizationAlias, reviewId }) => {
  const isMobile = useIsMobile();
  const cx = useStyles(styles);

  return (
    <>
      <div className={cx('wrapper')}>
        <Heading level={3}>
          Спасибо за отзыв! <GreenCheck />
        </Heading>
        <Text size={14} className={'h-mt-8 h-color-D60'}>
          Мы&nbsp;проверим отзыв и&nbsp;сообщим, когда он&nbsp;появится. В&nbsp;приложении Сравни ответ заметить проще
          и&nbsp;быстрее
        </Text>
        <Link href={'https://www.sravni.ru/analytics-links/v1/redirects/mobileapps/?placement=sravni_published_review'}>
          <Button size={52} variant={'secondary'} color={'blue'} block className={isMobile ? 'h-mt-16' : 'h-mt-24'}>
            Скачать приложение
          </Button>
        </Link>
      </div>

      <div className={cx('wrapper', isMobile ? 'h-mt-16' : 'h-mt-24')}>
        <ReviewModeration
          organizationType={organizationType}
          reviewId={reviewId}
          organizationAlias={organizationAlias}
        />
      </div>
    </>
  );
};
